export const SET_HOME = 'SET_HOME'
export const FETCH_UPDATES = '[ Frontend ] Fetch updates'
